import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTheme } from '../../theme-context';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { tryToFetchNotificationsSidebar } from '../../store/brokers/partners/notifications/notificationsSlice';
import { tryToFetchTeamMembersSidebar } from '../../store/brokers/partners/teams/teamsSlice';
import { tryToFetchActivitiesRightSide } from '../../store/brokers/partners/activities/activititesSlice';
import NotificationsModal from '../../components/notifications/NotificationsModal';
import ActivitesModal from '../../components/activities/ActivitiesModal';
import TeamsModal from '../../components/teams/TeamsModal';
import { CHAT_ACTIONS } from '../../utils/constants/chat-actions';
import { IToast } from '../../interfaces/components/IToast';
import Toast from '../../shared/toast';
import { classNames } from '../../utils/classNames';

interface IRightSidebar {
    onClickOpenChat: (action?: any) => void;
    isMobile?: boolean
}

const RightSidebar = ({
    onClickOpenChat,
    isMobile = false
}: IRightSidebar) => {
    const dispatch = useAppDispatch();
    const { theme } = useTheme();
    const [notifications, setNotifications] = useState<any>();
    const [members, setMembers] = useState<any>();
    const [activitites, setActivitites] = useState<any>();
    const [showMembersModal, setShowMembersModal] = useState<boolean>(false);
    const [showActivitiesModal, setShowActivitiesModal] = useState<boolean>(false);
    const [showNotificationsModal, setShowNotificationsModal] = useState<boolean>(false);
    const [showToast, setShowToast] = useState<IToast | null>();
    const notificationsData = useAppSelector((state) => state.notifications)
    const activitiesData = useAppSelector((state) => state.activities)
    const membersData = useAppSelector((state) => state.teams)

    useEffect(() => {
        setNotifications(notificationsData?.notificationsSidebar?.data?.elements)
    }, [notificationsData])

    useEffect(() => {
        setActivitites(activitiesData?.activitiesSidebar?.data?.elements)
    }, [activitiesData])

    useEffect(() => {
        setMembers(membersData?.teamMembersSidebar?.data?.elements)
    }, [membersData])

    const onGettingData = async () => {
        try {
            const data: any = {
                pageSize: 5,
                pageNumber: 1,
            }
            const notificationsData = {
                ...data || {},
                data: {
                    status: 'unread'
                }
            }
            await dispatch(tryToFetchTeamMembersSidebar(data)).unwrap();
            await dispatch(tryToFetchActivitiesRightSide(data)).unwrap();
            await dispatch(tryToFetchNotificationsSidebar(notificationsData)).unwrap();
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        onGettingData();
    }, [])

    const onClickShowTeamModals = () => {
        setShowMembersModal(!showMembersModal)
    }

    const onClickShowActivititesModals = () => {
        setShowActivitiesModal(!showActivitiesModal)
    }

    const onClickShowNotificationssModals = () => {
        setShowNotificationsModal(!showNotificationsModal)
    }

    const onSuccessfullyDeleted = async () => {
        setShowToast({ type: 'success', message: 'Members successfully deleted' });
        onGettingData();
    }

    const formatNotificationsTitle = (title: string) => {
        return title
            .replace(/_/g, ' ')
            .replace(/\w\S*/g, word =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            );
    }

	console.log({showNotificationsModal})

    return (
        <div
            className={`${isMobile ? 'w-64 h-full flex flex-col bg-white dark:bg-bgColor-darkMode' : classNames('hidden md:flex md:w-64 border-l md:right-0 md:inset-y-0 border-l-1 dark:border-borderColor-darkMode dark:bg-bgColor-darkMode', showNotificationsModal ? 'md:absolute top-5' : 'md:fixed')}`}
        >
            <div className='min-h-screen w-full p-4 overflow-y-auto px-3 py-2'>
                <div className='mb-7'>
                    <div className='cursor-pointer hover:opacity-80' onClick={onClickShowNotificationssModals}>
                        <h2 className='text-sm font-semibold mb-4 dark:text-primary-dark'>Notifications <span className='text-primary-light !font-normal'>({notificationsData?.notificationsSidebar?.data?.page?.totalElements || 0} Unread)</span></h2>
                    </div>
                    {notifications && notifications?.length > 0 && notifications?.filter((item: any, index: number) => index < 5)?.map((item: any, idx: number) => {
                        const timeAgo = moment(item?.createdAt).fromNow();
                        return (
                            <div key={idx} className='flex flex-row items-start mb-4'>
                                {item?.action ? <img src={'/assets/navigation-icons/sidebar/notification-user.svg'} className={'object-contain w-[30px] mr-2 pt-1'} />
                                    : <div className='min-w-[30px] min-h-[30px] mr-2 !rounded-8 bg-[#E5ECF6]'>
                                    </div>
                                }
                                <div>
                                    <p className='dark:text-primary-dark'>{formatNotificationsTitle(item?.action || '')}</p>
                                    <p className='text-primary-light dark:text-primary-dark'>{timeAgo}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className='mb-7'>
                    <div className='cursor-pointer hover:opacity-80' onClick={onClickShowActivititesModals}>
                        <h2 className='text-sm font-semibold mb-4 dark:text-primary-dark'>Activities <span className='text-primary-light !font-normal'>({activitiesData?.activitiesSidebar?.data?.page?.totalElements || 0} Today)</span></h2>
                    </div>
                    {(activitites && activitites?.length > 0) && activitites?.filter((item: any, index: number) => index < 5)?.map((item: any, idx: number) => {
                        const timeAgo = moment(item?.createdAt).fromNow();
                        return (
                            <div key={idx} className='mb-4 flex flex-row items-start'>
                                <img src={'/assets/navigation-icons/sidebar/activities.svg'} className='object-contain w-[30px] mr-2' />
                                <div className='w-[85%]'>
                                    <p className='truncate dark:text-primary-dark max-w-[200px]'>{item?.name}</p>
                                    <p className='text-primary-light mt-1'>{timeAgo}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className='mb-7'>
                    <div className='flex flex-row justify-between items-center mb-4 '>
                        <div className='cursor-pointer hover:opacity-80' onClick={onClickShowTeamModals}>
                            <h2 className='text-sm font-semibold dark:text-primary-dark'>Team <span className='text-primary-light !font-normal'>({membersData?.teamMembers?.data?.page?.totalElements} Members)</span></h2>
                        </div>
                        <div className='cursor-pointer hover:opacity-80' onClick={() => onClickOpenChat(CHAT_ACTIONS?.find((item: any) => item?.enum === 'onboarding'))}>
                            <img src={theme === 'dark' ? '/assets/navigation-icons/sidebar/add-icon-white.svg' : '/assets/navigation-icons/sidebar/add-icon.svg'} className={'object-contain w-[18px] mr-4'} />
                        </div>
                    </div>
                    {(members && members?.length > 0) && members?.map((item: any, idx: number) => {
                        return (
                            <div key={idx} className='flex flex-row mb-4 items-center dark:text-primary-dark'>
                                {item?.userIcon ? <img src={item?.userIcon} className='object-contain w-[30px] mr-2 !rounded-full' /> :
                                    <img src={'/assets/navigation-icons/sidebar/notification-user.svg'} className={'object-contain w-[30px] mr-2 !rounded-full'} />}
                                {(item?.name || item?.lastName) ?
                                    <div className='w-[80%]'>
                                        <p className='truncate'>{item?.name} {item?.lastName}</p>
                                    </div>
                                    : <div className={'w-[80%]'}>
                                        <p className='truncate'>{item?.email}</p>
                                    </div>
                                }
                            </div>
                        )
                    })}
                </div>
            </div>
            {showMembersModal &&
                <TeamsModal
                    openModal={showMembersModal}
                    handleCloseModal={onClickShowTeamModals}
                    SuccessfullyDeleted={onSuccessfullyDeleted}
                />
            }
            {showActivitiesModal &&
                <ActivitesModal
                    openModal={showActivitiesModal}
                    handleCloseModal={onClickShowActivititesModals}
                />
            }
            {showNotificationsModal &&
                <NotificationsModal
                    openModal={showNotificationsModal}
                    handleCloseModal={onClickShowNotificationssModals}
                />
            }
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </div>
    )
}

export default RightSidebar;